import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import { CustomSingleSelectModel } from "../CustomSingleSelect";
import { GetInvoiceByIdResponse, GetInvoiceByIdResponseFileArchive, GetInvoiceByIdResponseInvoiceDetail } from "../../models/response/invoice/GetInvoiceByIdResponse";
import { storeActivityIndicator } from "../../redux/reducers/authSlice";
import { InvoiceService } from "../../services/InvoiceService";
import { Helpers } from "../../helpers/Helpers";
import { ToolbarWrapper } from "../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../_metronic/layout/core";
import Box from "../Box";
import Content from "../../_metronic/layout/components/content/Content";
import PageHeader from "../PageHeader";
import CommonInvoiceGeneralInformation from "./Components/CommonInvoiceGeneralInformation";
import CommonInvoiceInvoiceDetails from "./Components/CommonInvoiceInvoiceDetails";
import CommonInvoiceTotalInformation from "./Components/CommonInvoiceTotalInformation";
import CommonInvoiceFileArchives from "./Components/CommonInvoiceFileArchives";
import { KTCard } from "../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../_metronic/helpers/components/KTCardBody";
import { AddInvoiceResponse } from "../../models/response/invoice/AddInvoiceResponse";
import { AddInvoiceRequest } from "../../models/request/invoice/AddInvoiceRequest";
import { ConstantService } from "../../services/ConstantService";
import { GetConstantListResponse } from "../../models/response/constant/GetConstantListResponse";
import { GetActiveCurrencyConversions } from "../../models/response/currencyConversion/GetActiveCurrencyConversions";
import { CurrencyConversionService } from "../../services/CurrencyConversionService";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import CustomSwitch from "../CustomSwitch";
import CustomTextInput from "../CustomTextInput";

interface Props {
    pageName: string
    isSale: boolean
    isPurchase: boolean
    isRefund: boolean
}

const CommonInvoiceAdd = ({ pageName, isSale, isPurchase, isRefund }: Props) => {
    const auth = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const generalInformationRef: any = useRef();
    const invoiceDetailsRef: any = useRef();
    const totalInformationRef: any = useRef();
    const fileArchivesRef: any = useRef();
    const withholdingStatusRef: any = useRef();

    const [invoiceId, setInvoiceId] = useState<string | undefined>(undefined);

    // GENEL BİLGİLER
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [selectedInvoiceStatus, setSelectedInvoiceStatus] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCurrencyType, setSelectedCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCurrentCompany, setSelectedCurrentCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [invoiceDate, setInvoiceDate] = useState<string | undefined>(moment(new Date()).format("YYYY-MM-DD"));
    const [currencyDate, setCurrencyDate] = useState<string | undefined>(moment(new Date()).format("YYYY-MM-DD"));
    const [selectedAddressType, setSelectedAddressType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [addressText, setAddressText] = useState<string | undefined>(undefined);
    const [serialNo, setSerialNo] = useState<string | undefined>(undefined);
    const [selectedCurrencyRateType, setSelectedCurrencyRateType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedPaymentType, setSelectedPaymentType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [currency, setCurrency] = useState<string | undefined>();
    const [selectedModule, setSelectedModule] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedMaturityPeriod, setSelectedMaturityPeriod] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedOperationType, setSelectedOperationType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [paymentDate, setPaymentDate] = useState<string | undefined>(undefined);
    const [transferDate, setTransferDate] = useState<string | undefined>(undefined);
    const [selectedInvoiceCategory, setSelectedInvoiceCategory] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [description, setDescription] = useState<string | undefined>(undefined);

    // FATURA DETAYLARI
    const [invoiceDetails, setInvoiceDetails] = useState<GetInvoiceByIdResponseInvoiceDetail[]>([]);

    // DOSYA ARŞİV
    const [fileArchives, setFileArchives] = useState<GetInvoiceByIdResponseFileArchive[]>([]);

    const [isCustomerWithholding, setIsCustomerWithholding] = useState(false);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, []);

    const getCurrency = async (_selectedCurrencyType: CustomSingleSelectModel | undefined, _selectedCurrencyRateType: CustomSingleSelectModel | undefined, _currencyDate: string | undefined, _closeLoading: boolean = true) => {
        if (_selectedCurrencyType && _selectedCurrencyRateType && _currencyDate && !Helpers.isEmpty(_currencyDate)) {
            try {
                dispatch(storeActivityIndicator(true));

                var response: GetActiveCurrencyConversions = await CurrencyConversionService.getActiveCurrencyConversions(_currencyDate);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                var tempCurrency = response.data.find(x => x.toCurrencyId == _selectedCurrencyType.value);

                if (tempCurrency) {
                    setCurrency(_selectedCurrencyRateType.additionalValue1 == "1" ? tempCurrency.sellStr.replace(',', '.') : tempCurrency.buyStr.replace(',', '.'));
                }
                else {
                    if (_selectedCurrencyType.label == 'TRY')
                        setCurrency("1")
                    else
                        setCurrency('');
                }
            }
            catch (error: any) {
                toast.error(error)
            }
            finally {
                if (_closeLoading)
                    dispatch(storeActivityIndicator(false))
            }
        }
        else {
            setCurrency('');
        }
    }

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            // Yeni faturada varsayilan tip Temel Fatura (INVOICE_TYPE anahtar 1; 06.10.2026, eskiden Ticari).
            var response5: GetConstantListResponse = await ConstantService.getConstantList('INVOICE_TYPE', undefined, "1");

            if (!response5.isSuccess) {
                toast.error(response5.message)
                return;
            }

            if (response5.data.length > 0) {
                setSelectedInvoiceType({ label: response5.data[0].value + '', value: response5.data[0].constantId });
            }

            var response4: GetConstantListResponse = await ConstantService.getConstantList('CURRENCY', undefined, "EUR");

            if (!response4.isSuccess) {
                toast.error(response4.message)
                return;
            }

            if (response4.data.length > 0) {
                setSelectedCurrencyType({ label: response4.data[0].additionalValue1 + '', value: response4.data[0].constantId });
            }

            var response3: GetConstantListResponse = await ConstantService.getConstantList('INVOICE_STATUS', undefined, "1");

            if (!response3.isSuccess) {
                toast.error(response3.message)
                return;
            }

            if (response3.data.length > 0) {
                setSelectedInvoiceStatus({ label: response3.data[0].value, value: response3.data[0].constantId });
            }

            var response2: GetConstantListResponse = await ConstantService.getConstantList('CURRENCY_TYPE', undefined, "1");

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            if (response2.data.length > 0) {
                setSelectedCurrencyRateType({ label: response2.data[0].value, value: response2.data[0].constantId, additionalValue1: response2.data[0].additionalValue1 });
            }

            await getCurrency({ label: response4.data[0].additionalValue1 + '', value: response4.data[0].constantId }, { label: response2.data[0].value, value: response2.data[0].constantId, additionalValue1: response2.data[0].additionalValue1 }, moment(new Date()).format("YYYY-MM-DD"), false);

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetInvoiceByIdResponse = await InvoiceService.getInvoiceById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setInvoiceId(response.data.invoiceId);

                setRefNo(response.data.refNo);

                if (response.data.invoiceStatusId && response.data.invoiceStatusName)
                    setSelectedInvoiceStatus({ label: response.data.invoiceStatusName, value: response.data.invoiceStatusId });

                if (response.data.currencyTypeId && response.data.currencyTypeName)
                    setSelectedCurrencyType({ label: response.data.currencyTypeName, value: response.data.currencyTypeId });

                if (response.data.currentCompanyId && response.data.currentCompanyName)
                    setSelectedCurrentCompany({ label: response.data.currentCompanyName, value: response.data.currentCompanyId });

                setInvoiceDate(response.data.invoiceDate);
                setCurrencyDate(response.data.currencyDate);

                if (response.data.currentCompanyAddressTypeId && response.data.currentCompanyAddressTypeName)
                    setSelectedAddressType({ label: response.data.currentCompanyAddressTypeName, value: response.data.currentCompanyAddressTypeId });

                setSerialNo(response.data.serialNo);

                if (response.data.currencyRateTypeId && response.data.currencyRateTypeName)
                    setSelectedCurrencyRateType({ label: response.data.currencyRateTypeName, value: response.data.currencyRateTypeId, additionalValue1: response.data.currencyRateTypeKey });

                setAddressText(response.data.addressText);

                if (response.data.paymentTypeId && response.data.paymentTypeName)
                    setSelectedPaymentType({ label: response.data.paymentTypeName, value: response.data.paymentTypeId, additionalValue1: response.data.paymentTypeKey });

                setCurrency(response.data.currency?.toFixed(4));

                if (response.data.moduleId && response.data.moduleName)
                    setSelectedModule({ label: response.data.moduleName, value: response.data.moduleId });

                if (response.data.maturityPeriodId && response.data.maturityPeriodName)
                    setSelectedMaturityPeriod({ label: response.data.maturityPeriodName, value: response.data.maturityPeriodId, additionalValue1: response.data.maturityPeriodKey });

                if (response.data.invoiceTypeId && response.data.invoiceTypeName)
                    setSelectedInvoiceType({ label: response.data.invoiceTypeName, value: response.data.invoiceTypeId });

                if (response.data.operationTypeId && response.data.operationTypeName)
                    setSelectedOperationType({ label: response.data.operationTypeName, value: response.data.operationTypeId });

                setPaymentDate(response.data.paymentDate);
                setTransferDate(response.data.transferDate);

                if (response.data.invoiceCategoryId && response.data.invoiceCategoryName)
                    setSelectedInvoiceCategory({ label: response.data.invoiceCategoryName, value: response.data.invoiceCategoryId });

                setInvoiceDetails(response.data.invoiceDetails);
                setDescription(response.data.description)
                setFileArchives(response.data.fileArchives);
                setIsCustomerWithholding(response.data.isCustomerWithholding);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveInvoice = async () => {
        try {
            if (!selectedInvoiceStatus)
                toast.error('Fatura Durumu alanını doldurunuz!')
            else if (!selectedCurrencyType)
                toast.error('Döviz Cinsi alanını doldurunuz!')
            else if (!selectedCurrentCompany)
                toast.error('Müşteri alanını doldurunuz!')
            else if (Helpers.isEmpty(invoiceDate))
                toast.error('Fatura Tarihi alanını doldurunuz!')
            else if (Helpers.isEmpty(currencyDate))
                toast.error('Kur Tarihi alanını doldurunuz!')
            else if (!selectedAddressType)
                toast.error('Adres Türü alanını doldurunuz!')
            else if (Helpers.isEmpty(serialNo))
                toast.error('Fatura Seri/No alanını doldurunuz!')
            else if (!selectedCurrencyRateType)
                toast.error('Kur Tipi alanını doldurunuz!')
            else if (Helpers.isEmpty(addressText))
                toast.error('Açık Adres alanını doldurunuz!')
            else if (!selectedPaymentType)
                toast.error('Ödeme Şekli alanını doldurunuz!')
            else if (Helpers.isEmpty(currency))
                toast.error('Kur alanını doldurunuz!')
            // else if (!selectedMaturityPeriod)
            //     toast.error('Ödeme Vadesi alanını doldurunuz!')
            else if (!selectedInvoiceType)
                toast.error('Fatura Tipi alanını doldurunuz!')
            else if (Helpers.isEmpty(paymentDate))
                toast.error('Ödeme Tarihi alanını doldurunuz!')
            else if (!selectedInvoiceCategory)
                toast.error('Kategori alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddInvoiceRequest = {
                    invoiceId: invoiceId,
                    addressText: addressText,
                    currency: currency,
                    currencyDate: currencyDate,
                    currencyRateTypeId: selectedCurrencyRateType.value,
                    currencyTypeId: selectedCurrencyType.value,
                    currentCompanyAddressTypeId: selectedAddressType.value,
                    currentCompanyId: selectedCurrentCompany.value,
                    invoiceCategoryId: selectedInvoiceCategory.value,
                    invoiceDate: invoiceDate,
                    invoiceStatusId: selectedInvoiceStatus.value,
                    invoiceTypeId: selectedInvoiceType.value,
                    isPurchase: isPurchase ? 1 : 0,
                    isRefund: isRefund ? 1 : 0,
                    isSale: isSale ? 1 : 0,
                    moduleId: selectedModule?.value,
                    operationTypeId: selectedOperationType?.value,
                    paymentDate: paymentDate,
                    maturityPeriodId: selectedMaturityPeriod?.value,
                    paymentTypeId: selectedPaymentType.value,
                    refNo: refNo,
                    serialNo: serialNo,
                    transferDate: transferDate,
                    description: description,
                    invoiceDetails: invoiceDetails.map(function (x) {
                        return {
                            description: x.description,
                            exceptionId: x.exceptionId,
                            quantity: x.quantity,
                            serviceId: x.serviceId,
                            taxPrice: x.taxPrice,
                            taxRate: x.taxRate,
                            totalPrice: x.totalPrice,
                            totalWithoutTaxPrice: x.totalWithoutTaxPrice,
                            unitPrice: x.unitPrice,
                            withholdingId: x.withholdingId,
                            withholdingPrice: x.withholdingPrice,
                            tevkifatDisi: x.tevkifatDisi
                        }
                    }),
                    fileArchives: fileArchives.map(function (x) {
                        return {
                            description: x.description,
                            entityId: x.entityId,
                            file: x.fileArchiveFile,
                            fileName: x.fileName,
                            fileTypeId: x.fileTypeId,
                            fileArchiveId: x.fileArchiveId
                        }
                    }),
                }

                var response: AddInvoiceResponse = await InvoiceService.addInvoice(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Tevkifat Durumu', ref: withholdingStatusRef },
                            { text: 'Fatura Detayları', ref: invoiceDetailsRef },
                            { text: 'Toplam Bilgileri', ref: totalInformationRef },
                            { text: 'Dijital Arşiv', ref: fileArchivesRef },
                        ]}
                    />

                    <CommonInvoiceGeneralInformation
                        addressText={addressText}
                        currency={currency}
                        currencyDate={currencyDate}
                        generalInformationRef={generalInformationRef}
                        invoiceDate={invoiceDate}
                        paymentDate={paymentDate}
                        refNo={refNo}
                        selectedAddressType={selectedAddressType}
                        selectedCurrencyRateType={selectedCurrencyRateType}
                        selectedCurrencyType={selectedCurrencyType}
                        selectedCurrentCompany={selectedCurrentCompany}
                        selectedInvoiceCategory={selectedInvoiceCategory}
                        selectedInvoiceStatus={selectedInvoiceStatus}
                        selectedInvoiceType={selectedInvoiceType}
                        selectedMaturityPeriod={selectedMaturityPeriod}
                        selectedModule={selectedModule}
                        selectedOperationType={selectedOperationType}
                        selectedPaymentType={selectedPaymentType}
                        serialNo={serialNo}
                        setAddressText={setAddressText}
                        setCurrency={setCurrency}
                        setCurrencyDate={setCurrencyDate}
                        setInvoiceDate={setInvoiceDate}
                        setPaymentDate={setPaymentDate}
                        setRefNo={setRefNo}
                        setSelectedAddressType={setSelectedAddressType}
                        setSelectedCurrencyRateType={setSelectedCurrencyRateType}
                        setSelectedCurrencyType={setSelectedCurrencyType}
                        setSelectedCurrentCompany={setSelectedCurrentCompany}
                        setSelectedInvoiceCategory={setSelectedInvoiceCategory}
                        setSelectedInvoiceStatus={setSelectedInvoiceStatus}
                        setSelectedInvoiceType={setSelectedInvoiceType}
                        setSelectedMaturityPeriod={setSelectedMaturityPeriod}
                        setSelectedModule={setSelectedModule}
                        setSelectedOperationType={setSelectedOperationType}
                        setSelectedPaymentType={setSelectedPaymentType}
                        setSerialNo={setSerialNo}
                        setTransferDate={setTransferDate}
                        transferDate={transferDate}
                        isSale={isSale}
                        isPurchase={isPurchase}
                        isRefund={isRefund}
                        getCurrency={getCurrency}
                        setIsCustomerWithholding={setIsCustomerWithholding}
                    />

                    <div className='containerPart' ref={withholdingStatusRef}>
                        <KTCard className="ebbe-card mt-10">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Tevkifat Durumu</h4>

                                <div className='row'>
                                    <div className="col-md-4">
                                        <CustomSwitch
                                            labelText="Uygulanacak"
                                            isActive={!!invoiceDetails.find(x => x.withholdingId)}
                                            setIsActive={() => { }}
                                            disabled
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Alt Limit Altında</label>

                                        <Box flexDirection='row'>
                                            <Box width='80px'>
                                                <CustomSwitch
                                                    isActive={invoiceDetails.find(x => x.withholding) && !invoiceDetails.find(x => Helpers.toNumber(x.withholdingPrice ?? '0') > 0)}
                                                    setIsActive={() => { }}
                                                    disabled
                                                />
                                            </Box>
                                            <Box ml='15px' flexGrow={1}>
                                                <CustomTextInput value={invoiceDetails?.find(x => x.withholding)?.withholding?.lowerLimitVatIncluded?.toFixed(2) ?? ''} isDisabled />
                                            </Box>
                                        </Box>
                                    </div>

                                    <div className="col-md-4">
                                        <CustomSwitch
                                            labelText="Müşteri Tevkifat Sorumlusu"
                                            isActive={isCustomerWithholding}
                                            setIsActive={setIsCustomerWithholding}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <CommonInvoiceInvoiceDetails
                        invoiceDetails={invoiceDetails}
                        invoiceDetailsRef={invoiceDetailsRef}
                        isIncome={isSale || isRefund}
                        setInvoiceDetails={setInvoiceDetails}
                        isCustomerWithholding={isCustomerWithholding}
                        invoiceDate={invoiceDate}
                    />

                    <CommonInvoiceTotalInformation
                        currency={currency}
                        description={description}
                        invoiceDetails={invoiceDetails}
                        setDescription={setDescription}
                        totalInformationRef={totalInformationRef}
                    />

                    <CommonInvoiceFileArchives
                        fileArchives={fileArchives}
                        fileArchivesRef={fileArchivesRef}
                        setFileArchives={setFileArchives}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveInvoice}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default CommonInvoiceAdd;